import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'


const router = new Router({
  routes: [
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      hidden: true,
      meta: {
        title: '登录',
        notLogin: true
      }
    },
    {
      path: '/QrCodeJs',
      component: () => import('@/views/QrCode/index'),
      hidden: true,
      meta: {
        title: '二维码登录',
        notLogin: true
      }
    }, {
      path: '/QrCodeXs',
      component: () => import('@/views/QrCode/xsIndex'),
      hidden: true,
      meta: {
        title: '二维码登录',
        notLogin: true
      }
    },
    {
      path: '',
      component: Layout,
      redirect: 'home',
      meta: { title: '后台管理' },
      children: [{
        path: 'home',
        component: () => import('@/views/home/home'),
        name: 'home',
        meta: {
          title: '后台管理',
          icon: 'dashboard'
        }
      }]
    },
    {
      path: '/passWord',
      component: Layout,
      meta: { title: '修改密码' },
      children: [{
        path: 'passWord',
        component: () => import('@/views/layout/passWord'),
        name: 'passWord',
        meta: {
          title: '修改密码',
        }
      }]
    },
    {
      path: '/system',
      component: Layout,
      name: 'system',
      // redirect: 'system',
      meta: {
        title: '超级权限',
        icon: 'example',
        id: 0
      },
      children: [
        {
          path: '/Manage/Roles/Index',
          component: () => import('@/views/system/index'),
          name: 'role',
          meta: {
            title: '角色管理',
          }
        }, {
          path: '/Manage/Power/Index',
          name: 'power',
          component: () => import('@/views/system/power'),
          meta: {
            title: '权限管理'
          }
        }, {
          path: '/Manage/Site',
          name: 'basics',
          component: () => import('@/views/system/basics'),
          meta: {
            title: '基础设置'
          }
        }, {
          path: '/Manage/Admins/Index',
          name: "setup",
          component: () => import('@/views/system/setUp'),
          meta: {
            title: '管理员管理'
          }
        }, {
          path: '/Manage/Subject',
          name: "subject",
          component: () => import('@/views/system/subject'),
          meta: {
            title: '学科管理'
          }
        }, {
          path: '/medal',
          name: 'medal',
          component: () => import('@/views/VacationAnswerApply/medal'),
          meta: {
            title: '勋章管理'
          }
        }
      ]
    },
    //页面配置
    {
      path: '/RotationChart',
      name: 'RotationChart',
      component: Layout,
      meta: {
        title: '页面配置'
      },
      children: [
        {
          path: '/RotationChartindex',
          name: 'RotationChartIndex',
          component: () => import('@/views/RotationChart/RotationChartIndex'),
          meta: {
            title: '首页轮播图',
          }
        }
      ]
    },
    //区县
    {
      path: '/areaPower',
      component: Layout,
      name: 'areaPower',
      meta: {
        title: '区县管理',
        icon: 'example',
        id: 0
      },
      children: [
        {
          path: '/roleArea',
          component: () => import('@/views/areaViews/areaPower/index'),
          name: 'roleArea',
          meta: {
            title: '区县角色',
          }
        }, {
          path: '/powerArea',
          component: () => import('@/views/areaViews/areaPower/power'),
          name: 'powerArea',
          meta: {
            title: '区县权限',
          }
        }, {
          path: '/areaSetUp',
          component: () => import('@/views/areaViews/areaPower/setUp'),
          name: 'areaSetUp',
          meta: {
            title: '区县管理员',
          }
        }, {
          path: '/areaOnDuty',
          component: () => import('@/views/areaViews/areaPower/onDuty'),
          name: 'areaOnDuty',
          meta: {
            title: '区县轮值'
          }
        }, {
          path: '/recommend',
          name: 'recommend',
          component: () => import('@/views/areaViews/recommend/index'),
          meta: {
            title: '区县推荐'
          }
        },
        {
          path: '/teaDuty',
          name: 'teaDuty',
          component: () => import('@/views/teacherManage/teaDuty'),
          meta: {
            title: '排班规则'
          }
        }, {
          path: '/teaOnduty',
          name: 'teaOnduty',
          component: () => import('@/views/teacherManage/teaOnduty'),
          meta: {
            title: '个人答疑教师'
          }
        },
        {
          path: '/teamDutyList',
          component: () => import('@/views/teacherManage/msdyteacher'),
          name: 'teamDutyList',
          meta: {
            title: '名师答疑教师',
          }
        }
        //废弃：2022-06-16
        // ,{
        //   path: 'answerTeacherList',
        //   component: () => import('@/views/answerTeacher/answerTeacherList'),
        //   name: 'answerTeacherList',
        //   meta: {
        //     title: '答疑教师'
        //   }
        // }
      ]
    },
    //教师管理
    {
      path: '/teaManage',
      name: 'teaManage',
      component: Layout,
      meta: {
        title: '师生管理',
        id: 1
      },
      children: [{
        path: '/teacher',
        name: 'teacher',
        component: () => import('@/views/teacherManage/teaManage'),
        meta: {
          title: '教师列表'
        }
      }, {
        path: '/student',
        name: 'student',
        component: () => import('@/views/studentManage/stuManage'),
        meta: {
          title: '学生列表'
        }
      }, {
        path: '/magicLog',
        name: 'magicLog',
        component: () => import('@/views/studentManage/magicLog'),
        meta: {
          title: '魔方日志'
        }
      }, {
        path: '/loginLog',
        name: 'loginLog',
        component: () => import('@/views/studentManage/loginLog'),
        meta: {
          title: '登录日志'
        }
      }, {
        path: '/verifyLog',
        name: 'verifyLog',
        component: () => import('@/views/studentManage/verifyLog'),
        meta: {
          title: '验证码日志'
        }
      }
      ]
    },
    //学校管理
    {
      path: '/schoolManagement',
      name: 'schoolManagement',
      component: Layout,
      meta: {
        title: '学校管理',
        id: 3
      },
      children: [{
        path: '/schoolList',
        component: () => import('@/views/schoolManagement/schoolList'),
        name: 'schoolList',
        meta: {
          title: '学校列表'
        }
      }]
    },
    //微课程管理
    {
      path: '/courseManagement',
      component: Layout,
      name: 'courseManagement',
      meta: {
        title: '作业微课',
        id: 4
      },
      children: [
        {
          path: '/knowledgeTree',
          component: () => import('@/views/courseManagement/knowledgeTree'),
          name: 'knowledgeTree',
          meta: {
            title: '知识树'
          }
        },
        {
          path: '/videos',
          component: () => import('@/views/courseManagement/videos'),
          name: 'videos',
          meta: {
            title: '视频管理',
          }
        }
      ]
    },
    //名师导学答疑
    {
      path: '/liveTax',
      name: 'liveTax',
      component: Layout,
      meta: {
        title: '名师答疑',
        id: 5
      },
      children: [{
        path: '/liveList',
        name: 'liveList',
        component: () => import('@/views/liveTax/liveList'),
        meta: {
          title: '名师导学'
        }
      }, {
        path: '/rotation',
        name: 'rotation',
        component: () => import('@/views/liveTax/rotation'),
        meta: {
          title: '轮播图管理'
        }
      },
      {
        path: '/AnsweringQquestion',
        component: () => import('@/views/liveTax/AnsweringQquestion'),
        name: 'AnsweringQquestion',
        meta: {
          title: '名师答疑'
        }
      },
      {
        path: '/FamousTeacherAnswer',
        component: () => import('@/views/liveTax/FamousTeacherAnswer'),
        name: 'FamousTeacherAnswer',
        meta: {
          title: '名师答疑详情',
          show: true,
        }
      },
      ]
    },
    //志愿者答疑
    {
      path: '/VacationAnswerApply',
      component: Layout,
      name: 'VacationAnswerApply',
      meta: {
        title: '志愿者答疑',
      },
      children: [
        // {
        //   path: 'VacationAnswer',
        //   component: () => import('@/views/VacationAnswerApply/VacationAnswer'),
        //   name: 'VacationAnswer',
        //   meta: {
        //     title: '寒暑假期答疑详情'
        //   }
        // },
        {
          path: '/Approval',
          component: () => import('@/views/VacationAnswerApply/Approval'),
          name: 'Approval',
          meta: {
            title: '答疑申请审批'
          }
        },
        {
          path: '/Vacation',
          component: () => import('@/views/VacationAnswerApply/Vacation'),
          name: 'Vacation',
          meta: {
            title: '答疑分期时间'
          }
        }, {
          path: '/VacationAnswerInfo',
          name: 'VacationAnswerInfo',
          component: () => import('@/views/VacationAnswerApply/VacationAnswerInfo'),
          meta: {
            title: '教师答疑情况'
          }
        }, {
          path: '/VacationList',
          name: 'VacationList',
          component: () => import('@/views/VacationAnswerApply/VacationList'),
          meta: {
            title: '答疑学生详情'
          }
        }, {
          path: '/VacationStudentList',
          name: 'VacationStudentList',
          component: () => import('@/views/VacationAnswerApply/VacationStudentList'),
          meta: {
            title: '答疑学生列表'
          }
        },
        {
          path: '/blackHourse',
          name: 'blackHourse',
          component: () => import('@/views/VacationAnswerApply/blackHourse'),
          meta: {
            title: '黑名单'
          }
        },
        {
          path: '/blackList',
          name: 'blackList',
          component: () => import('@/views/VacationAnswerApply/blackList'),
          meta: {
            title: '系统黑名单'
          }
        }
        // , {
        //   path: 'SummerStatistics',
        //   name: 'SummerStatistics',
        //   component: () => import('@/views/VacationAnswerApply/SummerStatistics'),
        //   meta: {
        //     title: '暑期统计'
        //   }
        // }
      ]
    },
    //科普
    {
      path: '/sciOnline',
      component: Layout,
      name: 'sciOnline',
      hidden: true,
      meta: {
        title: '科普在线',
        id: 4,
      },
      children: [
        {
          path: '/videolist',
          component: () => import('@/views/sciOnline/index'),
          name: 'videolist',
          meta: {
            title: '科普视频'
          }
        }
      ]
    },
    //数据统计
    {
      path: '/Statistics',
      component: Layout,
      name: 'Statistics',
      meta: {
        title: '数据统计',
        id: 5
      },
      children: [
        {
          path: '/DataStatistics',
          component: () => import('@/views/Statistics/DataStatistics'),
          name: 'DataStatistics',
          meta: {
            title: '模块统计'
          }
        }, {
          path: '/DataStatisticsVideo',
          component: () => import('@/views/Statistics/DataStatisticsVideo'),
          name: 'DataStatisticsVideo',
          meta: {
            title: '视频统计'
          }
        }, {
          path: '/PeopleVisits',
          component: () => import('@/views/Statistics/PeopleVisits'),
          name: 'PeopleVisits',
          meta: {
            title: '人数访问量'
          }
        }, {
          path: '/DayVisits',
          component: () => import('@/views/Statistics/DayVisits'),
          name: 'DayVisits',
          meta: {
            title: '日统计'
          }
        }, {
          path: '/AnsweringQuestion',
          component: () => import('@/views/Statistics/AnsweringQuestion'),
          name: 'AnsweringQuestion',
          meta: {
            title: '区县天答疑统计'
          }
        }, {
          path: '/AnsweringAreaQuestion',
          component: () => import('@/views/Statistics/AnsweringAreaQuestion'),
          name: 'AnsweringAreaQuestion',
          meta: {
            title: '学生提问区域统计'
          }
        }, {
          path: '/FamousTeacher',
          component: () => import('@/views/Statistics/FamousTeacher'),
          name: 'FamousTeacher',
          meta: {
            title: '名师答疑'
          }
        },
        {
          path: '/statisticsPersonnel',
          name: 'statisticsPersonnel',
          component: () => import('@/views/Statistics/statisticsPersonnel'),
          meta: {
            title: '人员统计'
          }
        }, {
          path: '/statisticsQuestioning',
          component: () => import('@/views/Statistics/statisticsQuestioning'),
          name: 'statisticsQuestioning',
          meta: {
            title: '提问统计'
          }
        }, {
          path: '/statisticsVolunteer',
          component: () => import('@/views/Statistics/statisticsVolunteer'),
          name: 'statisticsVolunteer',
          meta: {
            title: '志愿者统计'
          }
        }, {
          path: '/areaDataUp',
          name: 'areaDataUp',
          component: () => import('@/views/Statistics/areaDataUp'),
          meta: {
            title: '区县数据上报'
          }
        }, {
          path: '/studentAsnwer',
          name: 'studentAsnwer',
          component: () => import('@/views/Statistics/studentAsnwer'),
          meta: {
            title: '学生答疑统计'
          }
        }, {
          path: '/teacherAsnwer',
          name: 'teacherAsnwer',
          component: () => import('@/views/Statistics/teacherAsnwer'),
          meta: {
            title: '教师答疑统计'
          }
        }
      ]
    },
    //心理服务统计
    {
      path: '/Psychology',
      component: Layout,
      name: 'Psychology',
      meta: {
        title: '心理服务',
        id: 6
      },
      children: [
        {
          path: '/PsychologyQuestioning',
          component: () => import('@/views/Psychology/PsychologyQuestioning'),
          name: 'PsychologyQuestioning',
          meta: {
            title: '心理提问统计'
          }
        }, {
          path: '/PsychologyVolunteer',
          component: () => import('@/views/Psychology/PsychologyVolunteer'),
          name: 'PsychologyVolunteer',
          meta: {
            title: '志愿者心理统计'
          }
        }, {
          path: '/PsychologyTeacherAnswers',
          component: () => import('@/views/Psychology/PsychologyTeacherAnswers'),
          name: 'PsychologyTeacherAnswers',
          meta: {
            title: '教师答疑情况'
          }
        }, {
          path: '/heartFollow',
          name: 'heartFollow',
          component: () => import('@/views/Psychology/heartFollow'),
          meta: {
            title: '心理跟进'
          }
        }, {
          path: '/heartFollowQueston',
          name: 'heartFollowQueston',
          component: () => import('@/views/Psychology/heartFollowQueston'),
          meta: {
            title: '心理跟进问题'
          }
        }, {
          path: '/heartQuestionList',
          name: 'heartQuestionList',
          component: () => import('@/views/Psychology/QuestionList'),
          meta: {
            title: '心里问题详情'
          }
        }
      ]
    },
    //区县团队值班
    {
      path: '/DtMage/TeamDuty',
      component: Layout,
      name: 'DtMage-TeamDuty',
      meta: {
        title: '团队值班',
        icon: 'example',
        id: 0
      },
      children: [{
        path: '/DtMage/TeamDutyApply',
        component: () => import('@/views/areaViews/areaTeamTeacher/teacher'),
        name: 'DtMage-TeamDutyApply',
        meta: {
          title: '团队教师审核',
        }
      }, {
        path: '/DtMage/TeamDutyList',
        component: () => import('@/views/areaViews/areaTeamTeacher/teacherList'),
        name: 'DtMage-TeamDutyList',
        meta: {
          title: '团队值班列表',
        }
      }]
    },
    //区县答疑情况
    {
      path: '/DtMage/Statistics',
      component: Layout,
      name: 'Statistics',
      meta: {
        title: "区县数据统计",
        icon: 'example',
        id: 0
      },
      children: [{
        path: '/DtMage/Statistics/AnswerQuestions',
        component: () => import('@/views/areaViews/areaStatistics/AnswerQuestions'),
        name: 'AnswerQuestions',
        meta: {
          title: "天答疑统计",
          icon: 'example',
          id: 0
        },
      }]
    },
    //区县轮值设置
    {
      path: '/DtMage',
      component: Layout,
      name: 'areaSchool',
      meta: {
        title: "轮值设置",
        icon: 'example',
        id: 0
      },
      children: [
        {
          path: '/DtMage/SchoolDuty',
          component: () => import('@/views/areaViews/areaSchool/school'),
          name: 'areaSchool',
          meta: {
            title: "轮值设置",
            icon: 'example',
            id: 0
          },
        }
      ]
    },
    //区县统计
    {
      path: '/Dtmage/Dtstatistics',
      component: Layout,
      name: '/Dtmage/Dtstatistics',
      meta: {
        title: "数据统计",
      },
      children: [
        {
          path: '/Dtmage/Dtstatistics/personnel',
          name: 'Dtmage/Dtstatistics/personnel',
          component: () => import('@/views/areaViews/Dtstatistics/personnel'),
          meta: {
            title: "人员统计",

          },
        },
        {
          path: '/Dtmage/Dtstatistics/question',
          name: 'Dtmage/Dtstatistics/question',
          component: () => import('@/views/areaViews/Dtstatistics/question'),
          meta: {
            title: "提问统计",
          },
        },
        {
          path: '/Dtmage/Dtstatistics/volunteer',
          name: 'Dtmage/Dtstatistics/volunteer',
          component: () => import('@/views/areaViews/Dtstatistics/volunteer'),
          meta: {
            title: "志愿者统计",
          },
        }
      ]
    },
    //区县心理服务统计
    {
      path: '/Dtmage/Psychology',
      component: Layout,
      name: '/Dtmage/Psychology',
      meta: {
        title: '心理服务',
        id: 6
      },
      children: [
        {
          path: '/Dtmage/Psychology/question',
          component: () => import('@/views/areaViews/Psychology/question'),
          name: 'Dtmage/Psychology/question',
          meta: {
            title: '心理提问统计'
          }
        }, {
          path: '/Dtmage/Psychology/volunteer',
          component: () => import('@/views/areaViews/Psychology/volunteer'),
          name: 'Dtmage/Psychology/volunteer',
          meta: {
            title: '志愿者心理统计'
          }
        }, {
          path: '/Dtmage/Psychology/TeacherAnswers',
          component: () => import('@/views/areaViews/Psychology/TeacherAnswers'),
          name: 'Dtmage/Psychology/TeacherAnswers',
          meta: {
            title: '教师答疑情况'
          }
        }
      ]
    },
    //问题列表
    {
      path: '/problemList',
      component: Layout,
      name: 'problemList',
      meta: {
        title: '问题列表',
      },
      children: [
        {
          path: 'index',
          component: () => import('@/views/problemList/index'),
          name: 'index',
          meta: {
            title: '问题列表'
          }
        },
      ]
    },
    //反馈
    {
      path: '/feedback',
      component: Layout,
      name: 'feedback',
      meta: {
        title: '反馈',
        id: 0
      }, children: [
        {
          path: '/feedback',
          component: () => import('@/views/feedback/feedback'),
          name: 'feedback',
          meta: {
            title: '反馈'
          }
        },
      ]
    },

    //大屏统计
    {
      path: '/bigScreen',
      name: 'bigScreen',
      component: () => import('@/views/bigScreen/index'),
      meta: {
        title: '大屏统计',
        // notLogin: true
      }
    },
    {
      path: '/qaDatas',
      name: 'qaDatas',
      component: () => import('@/views/bigScreen/qaDatas/index'),
      meta: {
        title: '寒暑假答疑服务数据',
        // notLogin: true
      }
    },
    //教师登录
    {
      path: '/loginSuccess',
      name: 'loginSuccess',
      component: () => import('@/views/loginSuccess/loginSuccess'),
      meta: {
        title: '登录',
        notLogin: true
      }
    },
    //教师登录
    {
      path: '/mingAnswer',
      name: 'mingAnswer',
      component: Layout,
      meta: {
        title: '名师团队答疑',
      },
      children: [
        {
          path: '/Duty/index',
          name: 'Duty-index',
          component: () => import('@/views/Tanswer/index'),
          meta: {
            title: '名师团队答疑',
          }
        }
      ]
    },
    //区县平台数据
    {
      path: '/areaUpload',
      component: Layout,
      name: 'areaUpload',
      meta: {
        title: '区县平台数据',
        id: 6
      },
      children: [
        {
          path: '/areaUpload/course',
          component: () => import('@/views/areaViews/areaUpload/course'),
          name: 'areaUpload/course',
          meta: {
            title: '名师课堂'
          }
        },
        {
          path: '/areaUpload/resource',
          component: () => import('@/views/areaViews/areaUpload/resource'),
          name: 'areaUpload/resource',
          meta: {
            title: '资源课程'
          }
        },
        {
          path: '/areaUpload/statistics',
          component: () => import('@/views/areaViews/areaUpload/statistics'),
          name: 'areaUpload/statistics',
          meta: {
            title: '概况统计'
          }
        },
        {
          path: '/areaUpload/question',
          component: () => import('@/views/areaViews/areaUpload/question'),
          name: 'areaUpload/question',
          meta: {
            title: '答疑情况'
          }
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!to.meta.notLogin) {
    let token = localStorage.getItem('loginToken') || '';
    let timestamp = new Date().getTime();
    let expires = localStorage.getItem('tokenExpires') || 0;
    console.log("ts", timestamp)
    console.log("expires", expires)
    if (token && expires > timestamp) {
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }

});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js